var _templateObject, _templateObject2;

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

import { styled, css } from '@creditas-ui/system';
import { variant } from '@creditas-ui/utilities';
import { Box } from '@creditas-ui/layout';
import { globalIconsWrapperProps } from './constants';
var base = css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n"])));
var sizes = variant({
  prop: 'size',
  variants: globalIconsWrapperProps
});
export var GlobalIconElement = styled(Box.withComponent('i', process.env.NODE_ENV === "production" ? {
  target: "e1n0vf3k0"
} : {
  target: "e1n0vf3k0",
  label: "GlobalIconElement"
}))(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  ", ";\n  ", ";\n"])), base, sizes);
//# sourceMappingURL=GlobalIcons.styles.js.map